<template>
  <div v-if="isVisible" class="custom-modal-overlay">
    <div class="custom-modal-container">
      <div class="custom-modal-header">
        <button @click="closeModal" class="close-button">
          <img src="@/assets/img/close.svg" alt="" />
        </button>
        <h5>Virtual Accounts Details</h5>
      </div>

      <div class="custom-modal-body">
        <div class="input-container">
          <label for="bank-name">Bank Name</label>
          <input
            type="text"
            class="form-control"
            id="bank-name"
            v-model="accountDetails.bankName"
            readonly
          />
        </div>
        <div class="input-container">
          <label for="account-name">Account Name</label>
          <input
            type="text"
            class="form-control"
            id="account-name"
            v-model="accountDetails.accountName"
            readonly
          />
        </div>

        <div class="input-container">
          <label for="account-number">Account Number</label>
          <input
            type="text"
            class="form-control"
            id="account-number"
            v-model="accountDetails.accountNumber"
            readonly
          />
        </div>

        <div class="input-container">
          <label for="terminal-id">Terminal ID</label>
          <select v-model="selectedTerminalId" class="form-control">
            <option disabled value="">Select</option>

            <option v-for="id in terminalOptions" :key="id" :value="id">
              {{ id }}
            </option>

            <option v-if="terminalOptions.length === 0" disabled value="">
              No terminal IDs found. Please ensure the agent has available
              terminals.
            </option>
          </select>
          <div v-if="terminalIdError" class="error-message">
            {{ terminalIdError }}
          </div>
        </div>

        <div class="input-container">
          <label for="terminal-id">Terminal Type</label>
          <select
            name="terminalType"
            id="terminalType"
            class="input-select"
            v-model="terminalType"
          >
            <option disabled value="">Select</option>
            <option value="Pocket POS">Pocket POS</option>
            <option value="Standard POS">Standard POS</option>
            <option value="MPOS">MPOS</option>
            <option value="Card Reader">Card Reader</option>
          </select>
          <div v-if="terminalTypeError" class="error-message">
            {{ terminalTypeError }}
          </div>
        </div>

        <div class="input-container">
          <label for="date-created">Date Created</label>
          <input
            type="text"
            class="form-control"
            id="date-created"
            :value="formatDate(accountDetails.createdAt)"
            readonly
          />
        </div>

        <!-- <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div> -->

        <div class="custom-modal-footer">
          <button class="update-btn" @click="validateAndSubmit">
            Update Changes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../store/axios";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  props: {
    accountDetails: {
      type: Object,
      required: true,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    terminalId: {
      type: String,
      default: "",
    },
    terminalOptions: {
      type: Array,
      default: () => [],
    },
    agentId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedTerminalId: this.terminalId,
      terminalType: "",
      errorMessage: "",
      terminalTypeError: "",
      terminalIdError: "",
    };
  },

  watch: {
    terminalId(newVal) {
      this.selectedTerminalId = newVal;
    },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },

    formatDate(date) {
      return moment(date).format("YYYY-MM-DD hh:mm A");
    },

    async fetchTerminalId() {
      try {
        const payload = {
          agentId: this.agentId,
        };

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/get-agent-terminal`,
          payload,
        );

        if (response.data && response.data.terminals) {
          this.terminalOptions = response.data.terminals.map(
            (terminal) => terminal.terminalId,
          );
        } else {
          this.terminalOptions = [];
        }
      } catch (error) {
        console.error("Error fetching terminal IDs:", error.message);
      }
    },

    validateAndSubmit() {
      this.terminalTypeError = "";
      this.terminalIdError = "";

      if (!this.terminalType) {
        this.terminalTypeError = "Please select a terminal type.";
      }
      if (!this.selectedTerminalId) {
        this.terminalIdError = "Please select a terminal ID.";
      }

      if (!this.terminalTypeError && !this.terminalIdError) {
        this.updateTerminalId();
      } else {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Please fill all required fields.",
        });
      }
    },

    async updateTerminalId() {
      this.errorMessage = "";

      try {
        const payload = {
          agentId: this.agentId,
          virtualAccountId: this.accountDetails._id,
          terminalId: this.selectedTerminalId,
          terminalType: this.terminalType,
        };

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/link-virtual-account`,
          payload,
        );

        if (response.data.status == "success") {
          this.$emit("update", this.selectedTerminalId);
          this.closeModal();
          setTimeout(() => {
            Swal.fire({
              title: "Success",
              text: "Virtual account linked successfully",
              icon: "success",
            });
          }, 3000);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.message || "Failed to update terminal ID",
          });
        }
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "An error occurred. Please try again.";

        Swal.fire({
          icon: "error",
          title: "Error",
          text: this.errorMessage,
        });
      }
    },
  },

  async mounted() {
    this.fetchTerminalId();
  },
};
</script>

<style scoped>
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.custom-modal-container {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  max-width: 760px;
  overflow: hidden;
  overflow-y: auto;
  max-height: 100vh;
}

.custom-modal-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: rgba(101, 179, 199, 0.1);
  padding: 16px;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: end;
  width: 100%;
}

.custom-modal-header h5 {
  color: #65b3c7;
  font-size: 32px;
  font-weight: 600;
}

.custom-modal-body {
  margin: 40px 49px;
}

.custom-modal-footer {
  text-align: center;
  width: 100%;
  max-width: 380px;
  margin: auto;
  margin-top: 40px;
}

.update-btn {
  border: none;
  outline: none;
  color: white;
  background: #65b3c7;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  padding: 16px;
  border-radius: 4px;
}

.input-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 16px;
}

.input-container input,
.input-container select {
  background: #fff;
  border: 1px solid #ced3dd;
  color: #9497b8;
}

.input-container label {
  font-weight: 600;
  color: black;
}

.input-select {
  background-color: #fff;
  cursor: not-allowed;
  color: #9a9a9a;
  opacity: 1;
  padding: 7px 18px;
  height: 40px;
  border-radius: 4px;
  outline: none;
  border: 1px solid #ddd;
}

.error-message {
  color: red;
  margin-top: 10px;
  font-size: 12px;
}
</style>
